import { useEffect } from "react";

import { queryClient } from "@/app";

export type UseListenRechargeInput = {
  rechargeId: string | null;
  onApproved: () => void;
};

export function useListenRecharge({
  rechargeId,
  onApproved,
}: UseListenRechargeInput) {
  if (!rechargeId) {
    return;
  }

  let eventSource: EventSource | null = null;

  useEffect(() => {
    eventSource = new EventSource(
      `${import.meta.env.VITE_PAYMENT_API_URL}/v1/recharges/events/${rechargeId}`,
    );

    eventSource.addEventListener("message", (event) => {
      const data = JSON.parse(event.data);

      if (data.isApproved) {
        onApproved();
        invalidatBalanceQueries();
        eventSource?.close();
      }
    });

    return () => {
      eventSource?.close();
    };
  }, []);
}

export function invalidatBalanceQueries() {
  queryClient.invalidateQueries({
    predicate(query) {
      return query.queryKey.includes("/v1/balances");
    },
  });
}
